export default "__VITE_ASSET__BnbUveMD__"